module.exports = __webpack_public_path__ + "img/mmi-about-photo-team-joff.dc5e73e2.png";